import distanceFromNowInWords from './distanceFromNow'

export default distanceFromNowInWords
